import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { getMsalInstance, getSignedInAccount } from "./msalInstance";

const LOGIN_REQUEST = { scopes: ["user.read"] };

export default class AuthService {
  login = async () => {
    const msalObject = await getMsalInstance();
    const result = await msalObject.loginPopup(LOGIN_REQUEST);

    msalObject.setActiveAccount(result.account);

    // v2 returns the raw JWT string directly; v1 wrapped it in idToken.rawIdToken.
    return result.idToken;
  };

  getToken = async () => {
    const msalObject = await getMsalInstance();
    const account = await getSignedInAccount();

    if (!account) {
      return null;
    }

    // v2 will not infer the account, and omitting it re-prompts on every page load.
    const request = { scopes: LOGIN_REQUEST.scopes, account: account };

    try {
      const result = await msalObject.acquireTokenSilent(request);

      return result.idToken;
    } catch (error) {
      // Consent or interaction required - fall back to an interactive popup.
      if (error instanceof InteractionRequiredAuthError) {
        const result = await msalObject.acquireTokenPopup(request);

        msalObject.setActiveAccount(result.account);

        return result.idToken;
      }

      throw error;
    }
  };

  logout = async () => {
    const msalObject = await getMsalInstance();

    return msalObject.logoutPopup();
  };
}
